import React from "react";
import { Link as GatsbyLink } from 'gatsby'
import {
  Box,
  Text,
  Center,
  Link
  } from '@chakra-ui/react'
import styled from '@emotion/styled';

const Icon = styled(Link)`
display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
    cursor: pointer;
    > p {
        color: #70A37F;
    }
    > div > svg {
        fill: #70A37F;
    }

    &:hover {
        > p {
            color: #40634A;
        }
        > div > svg {
            fill: #40634A;
        }
    }
`

const Newsfeed = (props) => {
  return (
    <Icon as={GatsbyLink} to="/news" _hover={{textDecoration: 'none'}}>
      <Center w="45%" mx="auto">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 67.156 44.771">
    <path id="newspaper-solid_copy" data-name="newspaper-solid copy" d="M64.358,64H10.26a2.8,2.8,0,0,0-2.8,2.8v.933H2.8a2.8,2.8,0,0,0-2.8,2.8v31.713a6.529,6.529,0,0,0,6.529,6.529H61.56a5.6,5.6,0,0,0,5.6-5.6V66.8A2.8,2.8,0,0,0,64.358,64ZM6.529,103.174a.933.933,0,0,1-.933-.933V73.327H7.462v28.914A.933.933,0,0,1,6.529,103.174Zm27.515-1.865H16.323a1.4,1.4,0,0,1-1.4-1.4v-.933a1.4,1.4,0,0,1,1.4-1.4H34.044a1.4,1.4,0,0,1,1.4,1.4v.933A1.4,1.4,0,0,1,34.044,101.309Zm24.251,0H40.573a1.4,1.4,0,0,1-1.4-1.4v-.933a1.4,1.4,0,0,1,1.4-1.4H58.3a1.4,1.4,0,0,1,1.4,1.4v.933A1.4,1.4,0,0,1,58.3,101.309ZM34.044,90.116H16.323a1.4,1.4,0,0,1-1.4-1.4v-.933a1.4,1.4,0,0,1,1.4-1.4H34.044a1.4,1.4,0,0,1,1.4,1.4v.933A1.4,1.4,0,0,1,34.044,90.116Zm24.251,0H40.573a1.4,1.4,0,0,1-1.4-1.4v-.933a1.4,1.4,0,0,1,1.4-1.4H58.3a1.4,1.4,0,0,1,1.4,1.4v.933A1.4,1.4,0,0,1,58.3,90.116Zm0-11.193H16.323a1.4,1.4,0,0,1-1.4-1.4V72.861a1.4,1.4,0,0,1,1.4-1.4H58.3a1.4,1.4,0,0,1,1.4,1.4v4.664A1.4,1.4,0,0,1,58.3,78.924Z" transform="translate(0 -64)"/>
  </svg>
   </Center>
   <Text textAlign="center" fontSize={{base: 'xs', md: 'sm'}}>
        News
    </Text>
   </Icon>
  );
};

export default Newsfeed;